var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInvoice(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.001,
    height: 22.401,
    viewBox: "0 0 21.001 22.401",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18075",
    "data-name": "Grupo 18075",
    transform: "translate(-64.495 -2.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_93",
    "data-name": "Grupo 93",
    transform: "translate(64.495 2.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_73",
    "data-name": "Trazado 73",
    d: "M9,5.5a.7.7,0,0,1,.7.7V8.3h2.1a.7.7,0,1,1,0,1.4H9.7v2.1a.7.7,0,1,1-1.4,0V9.7H6.2a.7.7,0,0,1,0-1.4H8.3V6.2A.7.7,0,0,1,9,5.5Z",
    transform: "translate(2.2 2.2)",
    fill: "#003082",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_74",
    "data-name": "Trazado 74",
    d: "M3.8,0h14a2.8,2.8,0,0,1,2.8,2.8V19.6a2.8,2.8,0,0,1-2.8,2.8H3.8A2.8,2.8,0,0,1,1,19.6V18.2H2.4v1.4A1.4,1.4,0,0,0,3.8,21h14a1.4,1.4,0,0,0,1.4-1.4V2.8a1.4,1.4,0,0,0-1.4-1.4H3.8A1.4,1.4,0,0,0,2.4,2.8V4.2H1V2.8A2.8,2.8,0,0,1,3.8,0Z",
    transform: "translate(0.4)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_75",
    "data-name": "Trazado 75",
    d: "M1.4,5.4V4.7a.7.7,0,1,1,1.4,0v.7h.7a.7.7,0,1,1,0,1.4H.7a.7.7,0,1,1,0-1.4Zm0,8.4v-.7a.7.7,0,0,1,1.4,0v.7h.7a.7.7,0,1,1,0,1.4H.7a.7.7,0,1,1,0-1.4Z",
    transform: "translate(0 1.6)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2307",
    "data-name": "Trazado 2307",
    d: "M1.4,19.757v-.7a.7.7,0,0,1,1.4,0v.7h.7a.7.7,0,1,1,0,1.4H.7a.7.7,0,1,1,0-1.4Z",
    transform: "translate(0 -8.556)",
    fill: "#003082"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInvoice);
export default __webpack_public_path__ + "static/media/icon_invoice.7c8ea385c394e2ff2fbb3d7c0265b06c.svg";
export { ForwardRef as ReactComponent };